import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "267",
  "slug": "spot-the-usa-from-satellite-imagery",
  "title": "How to Recognise the United States in Satellite Images",
  "excerpt": "The contiguous United States includes the western Cordillera, broad interior plains, and the Appalachian belt in the east.",
  "date": "2026-05-19",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/the-usa.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The contiguous United States includes the western Cordillera, broad interior plains, and the Appalachian belt in the east. The Great Lakes and Gulf coast provide recognisable regional outlines. Rectangular survey grids are common in parts of the interior, but they are only one of many land-use patterns."
    },
    {
      "type": "heading",
      "text": "The plains between two mountain systems"
    },
    {
      "type": "paragraph",
      "text": "Compare the Great Plains with the ridges of the Appalachians. This regional image shows the contiguous states rather than Alaska, Hawaii, or US territories."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Canada shares prairie grids and forested northern landscapes; Mexico shares southwestern desert terrain. Neither a straight road nor a circular field identifies which side of the border you are seeing. Use larger landforms and water bodies."
    }
  ],
  "imageAlt": "the United States regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
